"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Favicon = void 0;
const react_1 = require("react");
const Avatar_1 = require("../Avatar");
const Img_1 = require("../Img");
const getDomain = (url) => url.match(/^(?:[^:/]+:)?(?:\/{1,5})?(([^/$ .]+)\.([^/$ ]+))/i)?.[1];
const Favicon = (props) => {
    const { domain: _domain, url, size = 16, ...rest } = props;
    const domain = (0, react_1.useMemo)(() => _domain || getDomain(url || ''), [_domain, url]);
    if (!domain)
        return (0, react_1.createElement)(Avatar_1.Avatar, { name: url || domain, width: size, height: size, letters: 1 });
    return (0, react_1.createElement)(Img_1.Img, {
        ...rest,
        alt: domain + ' favicon',
        width: size,
        height: size,
        /**
         * Favicon services:
         * - https://icons.duckduckgo.com/ip2/{hostname}.ico
         * - https://www.google.com/s2/favicons?domain={domain}
         * - https://www.google.com/s2/favicons?domain_url={hostname}
         * - https://www.google.com/s2/favicons?sz=(16..32..64..128..256..512)&domain_url=...
         * - http://favicon.yandex.net/favicon/{domain-1}/{domain-2}/{domain-3}/...
         * - https://favicon.yandex.net/favicon/{hostname1}/{hostname2}/
         * - https://f1.allesedv.com/16/{hostname}
         * - https://besticon-demo.herokuapp.com/icon?url={hostname}&size=80..120..200
         */
        src: 'https://www.google.com/s2/favicons?sz=64&domain=' + domain,
        renderError: () => (0, react_1.createElement)(Img_1.Img, {
            ...rest,
            alt: domain + ' favicon',
            width: size,
            height: size,
            src: 'https://' + domain + '/favicon.ico',
            renderError: () => (0, react_1.createElement)(Avatar_1.Avatar, { name: domain.toUpperCase(), width: size, height: size, letters: 1 }),
        }),
    });
};
exports.Favicon = Favicon;
